import _ from 'lodash';

export default class Portal {
  constructor(Vue) {
    this.company = Vue.prototype.$company;
    this.dev = Vue.prototype.$dev;
    this.isLoaded = false;
    this.layout = {
      entity: {
        show: true,
      },
      modules: {
        show: true,
      },
      nav: {
        show: true,
      },
      script: {
        fluid: false,
      },
      fluid: false,
    };
    this.url = {
      endPoint: {
        core: '',
        app: '',
        auth: '',
        access: '',
        admin: '',
        dfe: '',
        file: '',
        amcLicenciado: '',
        remoteSql: '',
        paymentReminder: '',
        activity: '',
        amcPlm: '',
        marketing: '',
        faccionista: '',
        devolution: '',
        help: '',
        financial: '',
        bankbill: '',
        bankbill_partners: '',
        amcRepresentante: '',
        shipping: '',
        quotas: '',
        orders: '',
        store_liveshop: '',
        store_liveshop_guest: '',
        store_liveshop_tags: '',
        store_liveshop_order: '',
        store_liveshop_jobs: '',
        store_liveshop_participant: '',
        store_campaign_products: '',
        store_cart: '',
        store_product: '',
        store_resources: '',
        ws_store_liveshop: '',
        chatbot_integration: '',
        invoice: '',
        supplier_financial: '',
        supplier_order: '',
        payment: '',
        chatbot: '',
      },
      cache: {
        company: {
          json: '',
        },
      },
      script: '',
    };
    this.urlRedirectNotfoundButton = undefined;
    this.init();
  }

  init() {
    this.isLoaded = false;

    this.resetLayout();

    const mainDomain = this.getDomainName(
      (this.company.json.domain || []).find(i => i.includes('.online')),
    );

    const isStage = this.company.domain.includes('homologacao');
    const paymentDomain = isStage ? 'apigw.homologacao.online' : 'apigw.simplificamais.com.br';

    this.url = {
      endPoint: {
        core: `https://${this.company.domain}/dev/`,
        app: `https://${this.company.domain}/api/app`,
        auth: `https://${this.company.domain}/api/auth`,
        access: `https://${this.company.domain}/api/access`,
        admin: `https://${this.company.domain}/api/pro-admin`,
        dfe: `https://${this.company.domain}/api/dfe`,
        file: `https://${this.company.domain}/api/file`,
        remoteSql: `https://${this.company.domain}/api/remotesql`,
        paymentReminder: `https://${this.company.domain}/api/payment-reminder`,
        activity: `https://${this.company.domain}/api/activity`,
        marketing: `https://${this.company.domain}/api/marketing`,
        faccionista: `https://${this.company.domain}/api/faccionista`,
        devolution: `https://${this.company.domain}/api/devolution`,
        bankbill: `https://${this.company.domain}/api/bankbill`,
        bankbill_partners: `https://${this.company.domain}/api/bankbill-partners`,
        shipping: `https://${this.company.domain}/api/shipping`,
        quotas: `https://${this.company.domain}/api/quotas`,
        orders: `https://${this.company.domain}/api/orders`,
        store_liveshop: `https://${this.company.domain}/api/store/live`,
        store_liveshop_guest: `https://${this.company.domain}/api/store/live-guest`,
        store_liveshop_tags: `https://${this.company.domain}/api/store/live-tags`,
        store_liveshop_order: `https://${this.company.domain}/api/store/live-order`,
        store_liveshop_jobs: `https://${this.company.domain}/api/store/live-jobs`,
        store_liveshop_participant: `https://${this.company.domain}/api/store/live-participant`,
        store_campaign_products: `https://${this.company.domain}/api/store/campaign-products`,
        store_cart: `https://${this.company.domain}/api/store/cart`,
        store_product: `https://${this.company.domain}/api/store/product`,
        store_resources: `https://${this.company.domain}/api/store/resources`,
        ws_store_liveshop: `wss://websocket-store-liveshop.${mainDomain}/api`,
        paymentNegotiation: `https://${this.company.domain}/api/payment-negotiation`,
        supplier_financial: `https://${this.company.domain}/api/supplier-financial`,
        supplier_order: `https://${this.company.domain}/api/supplier-order`,
        notifications: `https://${this.company.domain}/api/notifications`,
        ws_notifications: `wss://websocket-notifications.${mainDomain}/api`,
        custom_features: `https://${this.company.domain}/api/custom-features`,
        chatbot_integration: `https://${this.company.domain}/api/chatbot-integration`,
        financial: `https://${this.company.domain}/api/financial`,
        help: `https://${this.company.domain}/api/help`,
        customer_service: `https://${this.company.domain}/api/customer-service`,
        ws_customer_service: `wss://websocket-customer-service.${mainDomain}/api`,
        invoice: `https://${this.company.domain}/api/invoice`,
        permission: `https://${this.company.domain}/api/permission`,
        payment: `https://${paymentDomain}/payment`,
        chatbot: `https://${this.company.domain}/api/chatbot`,
      },
      cache: {
        company: {
          json: '/cache/',
        },
      },
      script: '/script/',
    };

    this.urlRedirectNotfoundButton = undefined;
  }

  getDomainName(hostname = window.location.hostname) {
    return hostname
      .split('.')
      .filter((i, index) => index !== 0)
      .join('.');
  }

  resetLayout() {
    this.layout = {
      entity: {
        show: true,
      },
      modules: {
        show: true,
      },
      nav: {
        show: true,
      },
      script: {
        fluid: false,
      },
      fluid: false,
    };
    if (!_.has(this.company, 'json.entity')) {
      this.layout.entity.show = false;
    } else if (_.has(this.company, 'json.style.layout.entity.show')) {
      this.layout.entity.show = _.get(
        this.company,
        'json.style.layout.entity.show',
      );
    }

    if (_.size(this.company.json.module) === 0)
      this.layout.modules.show = false;

    if (
      _.get(this.company, 'json.style.layout.fluid') === true
      || _.get(this.company, 'json.style.layout.fluid') === 'true'
    )
      this.layout.fluid = true;
  }

  hexToRgb(hex) {
    return hex
      .replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`,
      )
      .substring(1)
      .match(/.{2}/g)
      .map(x => parseInt(x, 16));
  }

  loadColors(primary, secondary, active) {
    return new Promise((resolve, reject) => {
      if (!primary && _.has(this.company.json, 'style.color.primary'))
        primary = this.company.json.style.color.primary;
      if (!secondary && _.has(this.company.json, 'style.color.secondary'))
        primary = this.company.json.style.color.secondary;
      if (!active && _.has(this.company.json, 'style.color.active'))
        primary = this.company.json.style.color.active;

      if (document.getElementById('setRoot'))
        document.getElementById('setRoot').remove();
      if (document.getElementById('setPrimary'))
        document.getElementById('setPrimary').remove();
      if (document.getElementById('setSecondary'))
        document.getElementById('setSecondary').remove();

      const root = document.createElement('style');

      root.id = 'setRoot';
      root.innerHTML = `
        :root {
          ${primary ? `--color-primary: ${primary};` : ''}
          ${secondary ? `--color-secondary: ${secondary};` : ''}
          ${active ? `--color-active: ${active};` : ''}
          ${
  primary
    ? `--color-primary-rgb: ${this.hexToRgb(primary).join()};`
    : ''
}
          ${
  secondary
    ? `--color-secondary-rgb: ${this.hexToRgb(secondary).join()};`
    : ''
}
          ${
  active ? `--color-active-rgb: ${this.hexToRgb(active).join()};` : ''
}
        }
      `;
      document.head.appendChild(root);

      if (primary) {
        const newPrimary = document.createElement('style');
        newPrimary.id = 'setPrimary';
        newPrimary.innerHTML = `
          .btn-swal-primary{
            background: ${primary} !important;
            opacity: 0.9;
          }
          .btn-swal-primary:hover{
            opacity: 1.0;
          }

          .border-color-primary {
            border-color: ${primary} !important;
          }

          .btn-primary{
            background: ${primary} !important;
            opacity: 0.9;
          }
          .btn-primary:hover{
            opacity: 1.0;
          }
          .text-primary{
            color: ${primary} !important;
          }
          .color-primary{
            background: ${primary} !important;
          }

          .border-primary{
            border-color: ${primary} !important;
          }

          .multiselect__option--highlight {
            background: ${primary} !important;
            outline: none;
            color: #fff;
          }
          .multiselect__tag{
            background: ${primary} !important;
          }
          .multiselect__tag-icon:hover{
            background: ${primary} !important;
          }
          .multiselect__tag-icon:after{
            color: #fff !important;
          }
          .pagination>.active>a,
          .pagination>.active>a:focus,
          .pagination>.active>a:hover,
          .pagination>.active>span,
          .pagination>.active>span:focus,
          .pagination>.active>span:hover{
            background-color: ${primary};
            border-color: ${primary};
          }
          .pagination>li>a, .pagination>li>span {
            color: ${primary};
          }
          .nav-tabs li.active > a {
            color: ${primary} !important;
          }
          .nav-tabs a:hover {
            color: ${primary} !important;
          }
          .breadcrumb-item.active {
            color: ${primary} !important;
          }
          .cursor-pointer-primary:hover {
            color: ${primary} !important;
            cursor: pointer;
          }

          .btn-outline-primary {
            background-color: white !important;
            border: 1px solid ${primary} !important;
            color: ${primary} !important;
          }

          .btn-outline-primary:hover {
            background-color: ${primary} !important;
            border: 1px solid ${primary} !important;
            color: white !important;
          }
        `;
        document.head.appendChild(newPrimary);
      }

      if (secondary) {
        const newPrimary = document.createElement('style');
        newPrimary.id = 'setSecondary';
        newPrimary.innerHTML = `
          .btn-secondary{
            background: ${secondary} !important;
            opacity: 0.9;
          }
          .btn-secondary:hover{
            opacity: 1.0;
          }

          .border-secondary{
            border-color: ${secondary} !important;
          }

          .text-secondary{
            color: ${secondary} !important;
          }
          .color-secondary{
            background: ${secondary} !important;
          }

          ul.components ul a {
            background: ${secondary} !important;
          }

          #sidebar ul li.active > a, #sidebar a[aria-expanded="true"] {
            color: #fff;
            background: ${secondary} !important;
          }

          #sidebar .active {
            background: ${secondary} !important
          }

          .btn-outline-secondary {
            max-height: 2.5em;
            min-height: 2.5em;
            background-color: white !important;
            border: 1px solid ${secondary} !important;
            color: ${secondary} !important;
          }

          .btn-outline-secondary:hover,
          .btn-outline-secondary:disabled {
            background-color: ${secondary} !important;
            border: 1px solid ${secondary} !important;
            color: white !important;
          }

`;
        document.head.appendChild(newPrimary);
      }

      if (active) {
        const newPrimary = document.createElement('style');
        newPrimary.id = 'setActive';
        newPrimary.innerHTML = `
          .color-active {
            background: ${active} !important;
          }

        `;
        document.head.appendChild(newPrimary);
      }

      return resolve();
    });
  }

  clear() {
    this.init();
  }
}
